import React, { useState } from 'react';
import { X } from 'lucide-react';
import './DeleteModal.css';

const DeleteModal = ({ onClose, onConfirm }) => {
  const [pin, setPin] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(pin);
  };

  return (
    <div className="modal-overlay" data-testid="delete-modal" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">Confirmar Eliminación</h3>
          <button className="modal-close" onClick={onClose} data-testid="close-delete-modal-btn">
            <X size={20} />
          </button>
        </div>

        <div className="modal-body">
          <p className="modal-description">
            Esta acción no se puede deshacer. Por favor, ingrese el PIN para confirmar.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="pin-input-wrapper">
              <input
                type="password"
                data-testid="pin-input"
                className="pin-input"
                placeholder="PIN"
                maxLength="4"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                autoFocus
              />
            </div>

            <div className="modal-actions">
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={onClose}
                data-testid="cancel-delete-btn"
              >
                Cancelar
              </button>
              <button 
                type="submit" 
                className="btn btn-danger"
                data-testid="confirm-delete-btn"
              >
                Eliminar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
